import React from 'react';
import { useTranslation } from 'react-i18next';

function PrivacyPage() {
    const { t } = useTranslation();

    return (
        <div className="privacy-page">
            <section className="text-center lg:py-16" style={{
                border: "1px solid rgba(129, 140, 248, 0.1)",
                borderRadius: "20px",
                background: "linear-gradient(to right, rgba(129, 140, 248, 0.1), transparent, transparent)",
                boxShadow: "0 4px 30px rgba(0, 0, 0, 0.2)",
            }}>
                <div className="max-w-4xl mx-auto">
                    <h1 className="text-4xl md:text-6xl font-bold leading-tight text-gradient">
                        {t('privacyPage.title')}
                    </h1>
                    <p className="text-lg md:text-xl lg:py-8 with-shadow">
                        {t('privacyPage.subtitle')}
                    </p>
                </div>
            </section>

            <section className="py-20 lg:py-32" id="content">
                <div className="max-w-4xl mx-auto">
                    <div className="mb-8">
                        <p className="text-sm text-gray-600 mb-8">{t('privacyPage.lastUpdated')}</p>
                        <p className="text-lg mb-8 with-shadow">{t('privacyPage.intro')}</p>
                    </div>

                    <div className="space-y-12">
                        {/* Dati che raccogliamo */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('privacyPage.dataCollectionTitle')}</h2>
                            <p className="text-lg mb-4 with-shadow">{t('privacyPage.dataCollection')}</p>
                        </div>

                        {/* Google Analytics */}
                        <div>
                            <h3 className="text-xl font-semibold mb-3 text-gradient">{t('privacyPage.analyticsTitle')}</h3>
                            <p className="with-shadow">{t('privacyPage.analytics')}</p>
                        </div>

                        {/* Pubblicità */}
                        <div>
                            <h3 className="text-xl font-semibold mb-3 text-gradient">{t('privacyPage.advertisingTitle')}</h3>
                            <p className="with-shadow">{t('privacyPage.advertising')}</p>
                        </div>

                        {/* Donazioni PayPal */}
                        <div>
                            <h3 className="text-xl font-semibold mb-3 text-gradient">{t('privacyPage.donationsTitle')}</h3>
                            <p className="with-shadow">{t('privacyPage.donations')}</p>
                        </div>

                        {/* Cookie */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('privacyPage.cookiesTitle')}</h2>
                            <p className="with-shadow">{t('privacyPage.cookies')}</p>
                        </div>

                        {/* Come utilizziamo i dati */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('privacyPage.dataUsageTitle')}</h2>
                            <p className="with-shadow">{t('privacyPage.dataUsage')}</p>
                        </div>

                        {/* I tuoi diritti */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('privacyPage.rightsTitle')}</h2>
                            <p className="with-shadow">{t('privacyPage.rights')}</p>
                        </div>

                        {/* Modifiche alla Privacy Policy */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('privacyPage.changesTitle')}</h2>
                            <p className="with-shadow">{t('privacyPage.changes')}</p>
                        </div>

                        {/* Contatti */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('privacyPage.contactTitle')}</h2>
                            <p className="with-shadow">{t('privacyPage.contactInfo')}</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default PrivacyPage;
